<template>
    <div>
        <van-notify v-model="showNotice" message="请关注官方公众号" type="danger" @click="showQRcode()">
            <van-icon name="bell" style="margin-right: 4px;" />
        </van-notify>
        <div class="page-header">
            <img :src="memberInfo.headimgurl">
            <div class="page-header-title">
                <h5 class="site-desc">昵 称：{{memberInfo.nickname}}</h5>
                <p class="site-desc">卡 号：{{iccid}}</p>
                <!--<p class="site-desc">apn设置：<a :stylle="{color:'#2398e6'}" href="http://baidu.com">详细教程</a></p>-->
            </div>
        </div>
        <div class="home-nav">
            <van-row  justify="center" class="">
                <van-col span="8">
                    <div @click="$router.push({name:'index'})" class="">
                        <img src="../assets/images/query.fd2e6f2c.png">
                        <p>流量查询</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="$router.push({name:'recharge',query:{iccid:iccid}})" class="">
                        <img src="../assets/images/recharge.png">
                        <p>充值套餐</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="$router.push({name:'bind'})" class="">
                        <img src="../assets/images/auth.46bece58.png">
                        <p>查询卡号</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="$router.push({name:'order',query:{iccid:iccid}})" class="">
                        <img src="../assets/images/order.edc98302.png">
                        <p>充值记录</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="$router.push({name:'feedback'})" class="">
                        <img src="../assets/images/feedback.eb8634f3.png">
                        <p>投诉建议</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="checkCard" class="">
                        <img src="../assets/images/check.png">
                        <p>智能检测</p>
                    </div>
                </van-col>
                <van-col span="8" v-if="operator.exchangeSwitch==1">
                    <div @click="changeCard(iccid)" class="">
                        <img src="../assets/images/change.png">
                        <p>申请换卡</p>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="warm-tips" :style="{background: '#fff'}"><h5>说明</h5>
            <ol>
                <li>本卡需要实名认证充值套餐方可使用。（点击上方实名认证按提示规范操作。实名成功后充值套餐）</li>
                <li>为保证此卡稳定使用请不要随便更换设备及卡槽</li>
            </ol>
        </div>
        <van-dialog v-model="showQRcodeModal" :showConfirmButton="false" title="长按关注官方公众号">

                <img :src="qrcodeurl" style="display: block;width: 100%;"/>
                <div >充值查询，24小时客服在线</div>
            <a v-clipboard:copy="iccid" v-clipboard:success="onCopySuccess"
               v-clipboard:error="onCopyError" style="padding: .2rem 0;display: block;color: #3a8ee6">复制卡号
            </a>
        </van-dialog>
    </div>
</template>
<script>
    import Vue from "vue";
    import VueClipboard from 'vue-clipboard2'

    Vue.use(VueClipboard)
    export default {
        name: "App",
        data: () => ({
            token: '',
            memberInfo: {},
            iccid:'',
            cardlist:[],
            operator:{},
            showNotice:false,
            showQRcodeModal:false,
            showContent:false,
            qrcodeurl:''
        }),
        watch: {
            iccid(value) {
                sessionStorage.setItem('iccid', this.iccid)
                this.subscribeStatus()
                this.queryOperatorInfo();
            }
        },
        created() {
            if(this.$route.query.appid && this.$route.query.appid > 0){
                sessionStorage.setItem('appid',this.$route.query.appid)
            }
            this.fetchData('/member/info', {}, (res) => {
                if (res.code) {
                    this.memberInfo = res.data
                    if(this.memberInfo.subscribe == 0){
                        this.showNotice = true
                    }
                }
            })
            this.queryUserCards();
        },

        methods: {
            onCopySuccess() {
                this.$toast.success('复制成功')
            },
            onCopyError() {
                this.$toast.fail('复制失败');
            },
            subscribeStatus(){
                this.fetchData('/auth/subscribeStatus',{iccid:this.iccid},res=>{
                    if(res.code && res.url){
                        this.showQRcodeModal = true
                        this.qrcodeurl = res.url
                    }
                })
            },
            changeCard(iccid){
                this.fetchData('/change/getUrl',{iccid:iccid},(res)=>{
                    if(res.code && res.url){
                        window.location.href = res.url
                    }else{
                        this.$router.push({name:'change',query:{iccid:this.iccid}})
                    }
                })
            },
            queryStatus(){
                this.fetchData('/card/statusChange', {iccid: this.iccid}, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                        if(res.data.change == 1){
                            this.change = 1
                            if(this.operator.exchangeSwitch==1){
                                this.$dialog.alert({
                                    title: false,
                                    message: "当前卡已不支持续费，我们将为您补发一张卡",
                                    confirmButtonText: '立即换卡',
                                    showCancelButton:true
                                }).then(() => {
                                    this.changeCard(this.iccid)
                                });
                            }
                        }else if(res.data.change==2 && res.data.id){
                            this.$dialog.alert({
                                title: false,
                                message: "您已申请换卡，点击查看换卡进度",
                                confirmButtonText: '立即查看',
                                showCancelButton:true
                            }).then(() => {
                                this.$router.push({name:'changeInfo',query:{id:res.data.id}})
                            }).catch(()=>{});

                        }
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            queryUserCards() {
                this.fetchData('/card/querylist', {}, (res) => {
                    if (res.code) {
                        for (var i in res.data) {
                            let card = res.data[i];
                            this.cardlist.push({
                                name: card.iccid,
                                value: card.iccid
                            })
                            if (card.default == 1) {
                                this.iccid = card.iccid;
                            }
                        }
                    } else {
                        this.$dialog.alert({
                            title: false,
                            message: "检测到您还未绑卡，请先绑卡",
                            confirmButtonText: '去绑卡'
                        }).then(() => {
                            this.$router.push({name: 'bind'})
                        });

                    }
                })
            },
            queryOperatorInfo() {
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        this.queryStatus();
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            checkCard(){
                this.$toast.loading('诊断中')
                this.fetchData('/card/check',{iccid:this.iccid},(res)=>{
                    this.$toast.loading().close();
                    this.$toast(res.msg)
                })
            },
            showQRcode(){
                this.showQRcodeModal = true;
            }
        }
    };
</script>

<style>
    body, html {
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        padding: 0;
        margin: 0;
        padding-bottom: .3rem;
    }

    .page-header {
        height: 2.5rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        background: -webkit-gradient(linear, left top, left bottom, from(#3c6bff), to(#75b2f9));
        background: linear-gradient(#3c6bff, #75b2f9);
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
        box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
    }

    .page-header img {
        background: #fff;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 2rem;
        border: .05rem solid #75b2f9;
    }

    .page-header .page-header-title {
        color: #fff;
        font-weight: 700;
        text-align: left;
        padding-left: 0;
    }

    .page-header .page-header-title .site-title {
        padding: 0;
        margin: 0;
        line-height: .3rem;
    }

    .page-header .page-header-title .site-desc {
        margin: .1rem 0;
        padding: 0;
        font-size: .3rem;
    }

    .home-nav {
        width: 6.74rem;
        margin: auto;
        padding-top: .1rem;
        padding-bottom: .1rem;
        background: #fff;
        border-radius: .1rem;
        box-shadow: 0 0 0.02rem #dedede;
    }

    .home-nav img {
        margin: 0;
        width: .8rem;
        height: .8rem;
    }

    .home-nav p {
        margin-top: -.1rem;
        font-size: .22rem;
        color: #555;
    }

    .page-footer {
        bottom: .3rem;
        font-size: .16rem;
        color: #555;
        text-align: center;
        width: 7.5rem;
    }

    .page-footer a {
        color: #666;
        text-decoration: #3a8ee6;
    }

    .warm-tips {
        font-size: .25rem;
        margin: 0 .3rem;
        padding: 0 .3rem;
    }

    .warm-tips h5 {
        text-align: left;
        margin: .2rem 0;
        padding-left: .1rem;
        font-size: .3rem;
        border-left: .2rem solid #75b2f9;
    }

    .warm-tips ol {
        text-align: left;
        padding: 0;
        font-size: .24rem;
    }

    .warm-tips ol li {
        list-style: disc;
        line-height: .4rem;
    }

</style>



// WEBPACK FOOTER //
// src/pages/home.vue